import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Mission from './pages/routePages/Mission.js';
import Portfolio from './pages/routePages/Portfolio.js';
import Terms from './pages/routePages/Terms.js';
import PageNotFound from './pages/PageNotFound.js';
import Butter from './pages/projectPages/Butter.js';
import AIFree from './pages/projectPages/AIFree.js'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/mission" element={ <Mission/> } />
        <Route path="/portfolio" element={ <Portfolio/> } />
        <Route path="/terms" element={ <Terms/> } />
        <Route path="/butter" element={ <Butter/> } />
        <Route path="/ai-free-commitment" element={ <AIFree/> } />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
